import React, { PureComponent } from 'react';
// import PropTypes from 'prop-types';
import { StyledModal, StyledSearchFilterButton } from './style';
import FilterForm from './FilterForm';

const txtBtnFilter = 'Modificar filtros';
const txtBtnNoFilters = 'Buscar y filtrar';

class SearchFilter extends PureComponent {
  render() {
    const {
      onClick,
      closeModal,
      openModal,
      modalActive,
      filter,
      setFilter
    } = this.props;
    return (
      <div>
        {modalActive ? (
          <StyledModal title="Seleccionar filtros" clickCloseIcon={closeModal}>
            <FilterForm
              onClick={onClick}
              closeModal={closeModal}
              modalActive={modalActive}
              filter={filter}
              setFilter={setFilter}
            />
          </StyledModal>
        ) : (
          <React.Fragment>
            <FilterForm
              onClick={onClick}
              modalActive={modalActive}
              filter={filter}
              setFilter={setFilter}
            />
            <StyledSearchFilterButton
              onClick={openModal}
              modalActive={modalActive}
            >
              {Object.keys(filter).length > 0 ? txtBtnFilter : txtBtnNoFilters}
            </StyledSearchFilterButton>
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default SearchFilter;
